import { type ValidationError } from '@adv-frontend/form-kit';

export const MIN_VALUE_ERROR_CODE = 'MIN_VALUE_ERROR';

type MinValueErrorParams = {
    minValue: number;
};

export type MinValueValidationError = ValidationError<typeof MIN_VALUE_ERROR_CODE, MinValueErrorParams>;

export const MIN_VALUE_ERROR_MESSAGE = ({ minValue }: MinValueErrorParams) => `Минимальное значение ${minValue}`;
